import { useEffect, useState } from "react";
import { toast } from "sonner";

import { Badge } from "@/components/ui/badge";
import { apiGet, apiPatch } from "@/services/api";
import { formatPrice } from "@/lib/utils";

type VendorOrder = {
  id: string;
  status: string;
  subtotal: number;
  netAmount: number;
  createdAt: string;
  items: { id: string; title: string; quantity: number }[];
  order: { shippingFullName: string; paymentStatus: string } | null;
};

const STATUSES = ["ACCEPTED", "PROCESSING", "READY_TO_SHIP", "SHIPPED", "DELIVERED", "CANCELLED"];

export function VendorOrdersPage() {
  const [orders, setOrders] = useState<VendorOrder[]>([]);

  async function load() {
    const d = await apiGet<{ vendorOrders: VendorOrder[] }>("/api/vendors/me/orders");
    setOrders(d?.vendorOrders ?? []);
  }
  useEffect(() => {
    void load();
  }, []);

  async function setStatus(id: string, status: string) {
    try {
      await apiPatch(`/api/vendors/me/orders/${id}/status`, { status });
      toast.success("Order updated");
      void load();
    } catch {
      toast.error("Could not update order");
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Orders</h2>
      <div className="amazon-card divide-y divide-slate-100 dark:divide-white/10">
        {orders.length === 0 && <p className="p-6 text-sm text-slate-500">No orders yet.</p>}
        {orders.map((o) => (
          <div key={o.id} className="space-y-2 p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-bold">
                #{o.id.slice(-8)} · {o.order?.shippingFullName ?? "Customer"}
              </p>
              <Badge tone="prime">{o.status}</Badge>
            </div>
            <p className="text-xs text-slate-500">
              {o.items.map((i) => `${i.title} ×${i.quantity}`).join(", ")}
            </p>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-sm">
                Subtotal {formatPrice(o.subtotal)} · Net {formatPrice(o.netAmount)} ·{" "}
                {new Date(o.createdAt).toLocaleDateString()}
              </p>
              <select
                value={o.status}
                onChange={(e) => setStatus(o.id, e.target.value)}
                className="rounded border border-slate-300 px-2 py-1 text-sm dark:border-white/10 dark:bg-white/5"
              >
                {STATUSES.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
